import React from 'react';
import CookieConsent, { Cookies } from 'react-cookie-consent';

const CookieBanner = () => {
  return (
    <CookieConsent
      acceptOnScroll
      buttonText='Aceptar'
      buttonStyle={{
        backgroundColor: 'black',
        color: 'white',
        fontSize: '13px',
      }}
      cookieSecurity
      declineButtonText='Rechazar'
      enableDeclineButton
      location='bottom'
      onDecline={() => {
        Cookies.set('hasRespondedGdpr', true);
        Cookies.set('acceptCookiesGdpr', false);
      }}
      onAccept={() => {
        Cookies.set('hasRespondedGdpr', true);
        Cookies.set('acceptCookiesGdpr', true);
      }}
      style={{ background: 'rgba(254, 241, 225, 0.8)', color: 'black' }}
    >
      Esta página usa cookies para mejorar la experiencia del usuario{' '}
      <span style={{ fontSize: '10px' }}> Aceptar para continuar</span>
    </CookieConsent>
  );
};
export default CookieBanner;
